/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ APP_NAME: NonNullable<unknown> }} Account_Page_TitleInputs */

const en_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Account | ${i?.APP_NAME}`)
};

const id_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Akun | ${i?.APP_NAME}`)
};

const ms_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Akaun | ${i?.APP_NAME}`)
};

const ca_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compte | ${i?.APP_NAME}`)
};

const cs_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Účet | ${i?.APP_NAME}`)
};

const da_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konto | ${i?.APP_NAME}`)
};

const de_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Benutzerkonto | ${i?.APP_NAME}`)
};

const et_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konto | ${i?.APP_NAME}`)
};

const es_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cuenta | ${i?.APP_NAME}`)
};

const fr_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compte | ${i?.APP_NAME}`)
};

const hr_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Račun | ${i?.APP_NAME}`)
};

const it_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Account | ${i?.APP_NAME}`)
};

const lv_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konts | ${i?.APP_NAME}`)
};

const lt_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paskyra | ${i?.APP_NAME}`)
};

const hu_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Számla | ${i?.APP_NAME}`)
};

const nl_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Account | ${i?.APP_NAME}`)
};

const nb_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konto | ${i?.APP_NAME}`)
};

const pl_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konto | ${i?.APP_NAME}`)
};

const pt_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conta | ${i?.APP_NAME}`)
};

const ro_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cont | ${i?.APP_NAME}`)
};

const sk_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Účet | ${i?.APP_NAME}`)
};

const sl_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Račun | ${i?.APP_NAME}`)
};

const fi_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tili | ${i?.APP_NAME}`)
};

const sv_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konto | ${i?.APP_NAME}`)
};

const vi_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tài khoản | ${i?.APP_NAME}`)
};

const tr_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hesap | ${i?.APP_NAME}`)
};

const el_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Λογαριασμός | ${i?.APP_NAME}`)
};

const bg_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Акаунт | ${i?.APP_NAME}`)
};

const ru_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Аккаунт | ${i?.APP_NAME}`)
};

const sr_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Налог | ${i?.APP_NAME}`)
};

const uk_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Рахунок ${i?.APP_NAME}`)
};

const ka_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ანგარიში | ${i?.APP_NAME}`)
};

const hi_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अकाउंट | ${i?.APP_NAME}`)
};

const th_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`บัญชี | ${i?.APP_NAME}`)
};

const ko_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`계정 | ${i?.APP_NAME}`)
};

const zh_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`账户 | ${i?.APP_NAME}`)
};

const zh_tw_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`帳戶 | ${i?.APP_NAME}`)
};

const ja_account_page_title = /** @type {(inputs: Account_Page_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アカウント｜ ${i?.APP_NAME}`)
};

/**
* | output |
* | --- |
* | "Account \| {APP_NAME}" |
*
* @param {Account_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const account_page_title = /** @type {((inputs: Account_Page_TitleInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Page_TitleInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_account_page_title(inputs)
	if (locale === "ms") return ms_account_page_title(inputs)
	if (locale === "ca") return ca_account_page_title(inputs)
	if (locale === "cs") return cs_account_page_title(inputs)
	if (locale === "da") return da_account_page_title(inputs)
	if (locale === "de") return de_account_page_title(inputs)
	if (locale === "et") return et_account_page_title(inputs)
	if (locale === "es") return es_account_page_title(inputs)
	if (locale === "fr") return fr_account_page_title(inputs)
	if (locale === "hr") return hr_account_page_title(inputs)
	if (locale === "it") return it_account_page_title(inputs)
	if (locale === "lv") return lv_account_page_title(inputs)
	if (locale === "lt") return lt_account_page_title(inputs)
	if (locale === "hu") return hu_account_page_title(inputs)
	if (locale === "nl") return nl_account_page_title(inputs)
	if (locale === "nb") return nb_account_page_title(inputs)
	if (locale === "pl") return pl_account_page_title(inputs)
	if (locale === "pt") return pt_account_page_title(inputs)
	if (locale === "ro") return ro_account_page_title(inputs)
	if (locale === "sk") return sk_account_page_title(inputs)
	if (locale === "sl") return sl_account_page_title(inputs)
	if (locale === "fi") return fi_account_page_title(inputs)
	if (locale === "sv") return sv_account_page_title(inputs)
	if (locale === "vi") return vi_account_page_title(inputs)
	if (locale === "tr") return tr_account_page_title(inputs)
	if (locale === "el") return el_account_page_title(inputs)
	if (locale === "bg") return bg_account_page_title(inputs)
	if (locale === "ru") return ru_account_page_title(inputs)
	if (locale === "sr") return sr_account_page_title(inputs)
	if (locale === "uk") return uk_account_page_title(inputs)
	if (locale === "ka") return ka_account_page_title(inputs)
	if (locale === "hi") return hi_account_page_title(inputs)
	if (locale === "th") return th_account_page_title(inputs)
	if (locale === "ko") return ko_account_page_title(inputs)
	if (locale === "zh") return zh_account_page_title(inputs)
	if (locale === "zh-tw") return zh_tw_account_page_title(inputs)
	if (locale === "ja") return ja_account_page_title(inputs)
	return en_account_page_title(inputs)
});